import React from "react";
import routeGuard from "src/Hooks/routeGuard";
import { RESOURCE_TYPE } from "src/constant/common";
import SequenceList from "src/components/Sequence";

const Sequence = () => {
  return (
    <SequenceList />
  );
};

export default routeGuard(Sequence, RESOURCE_TYPE.PROJECT_INSTANCE);